import {Schema} from '@zaiusinc/app-forms-schema';
import {ZipApi} from './ZipApi';

export async function fetchRemoteData(
  section: string, field: string, source: Schema.DataSource, formData: Schema.FormSectionData, installId: number
): Promise<Schema.SelectOption[]> {
  if (source.type === 'app') {
    const fns = await ZipApi.listFunctions(installId);
    const url = fns[source.function];
    if (!url) {
      return [];
    }
    return await processResponse(await fetch(url, {
      method: 'POST',
      body: JSON.stringify({section, field, formData}),
      headers: {
        'Content-Type': 'application/json'
      }
    }));
  } else {
    if (source.url) {
      return await processResponse(await fetch(source.url, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      }));
    }
    return [];
  }
}

async function processResponse(response: Response) {
  if (!response.ok) {
    throw new Error(await buildHttpErrorMessage(response));
  }

  const result = await response.json();
  if (!Array.isArray(result)) {
    return [];
  }

  return result;
}

const MAX_BODY_LENGTH = 200;

async function buildHttpErrorMessage(response: Response): Promise<string> {
  const prefix = `Failed to load options (HTTP ${response.status})`;
  try {
    const text = await response.text();
    if (!text) {
      return prefix;
    }
    try {
      const json = JSON.parse(text);
      const detail = json.message || json.error;
      if (typeof detail === 'string') {
        return `${prefix}: ${detail}`;
      }
    } catch {
      // not JSON
    }
    if (text.length <= MAX_BODY_LENGTH) {
      return `${prefix}: ${text}`;
    }
  } catch {
    // couldn't read body
  }
  return prefix;
}
